<template>
  <!--타이틀-->
    <el-row class="wordCountInfo" style="height: 100%; overflow: hidden">
      <div style="width:100%; float:left">
        <div class="title-bar" style="height: 43px; margin: 0 !important">
          <h3>로그 연관 단어 발생횟수</h3>
        </div>
        <p>발생한 글자 수 목록</p>
      </div>
      <div style="width: 100%; float:left; margin-top: 20px">
        <div class="mr-b25">
          <w-search-field ref="groupSearch" class="mr-b15" @search="searchGroup"/>
          <el-table-wrapper
            :column-default="columnDefault"
            ref="logGroupTable"
            :data="wordCountGroupData"
            :columns="groupColumn"
            :pagination="false"
            :show-custom-header="false"
            header-align="center"
            :show-search-tool="showSearchTool"
            @selection-change="changeSelection"
            @cell-click="filterNodeTable"
            highlight-current-row
            height="166">
            <template slot-scope="scope" slot="groupName-slot">
              <span class="c-pointer">
                {{scope.row.fieldName}}
              </span>
            </template>
          </el-table-wrapper>
        </div>
        <w-search-field ref="nodeSearch" class="mr-b15" @search="searchNode"/>
        <div>
          <el-table-wrapper
            :column-default="columnDefault"
            ref="logNodeTable"
            :data="wordCountData"
            :columns="nodeColumn"
            :pagination="false"
            :show-custom-header="false"
            header-align="center"
            :show-search-tool="showSearchTool"
            highlight-current-row
            @cell-click="wordClick"
            @cell-mouse-enter="hoverNode"
            @cell-mouse-leave="leaveNode"
            :height="height">
            <template slot-scope="scope" slot="wordCount-slot">
              <span class="c-pointer">
                {{`${scope.row.label} (${((scope.row.size/sum) * 100).toFixed(2)} %)`}}
              </span>
            </template>
          </el-table-wrapper>
        </div>
      </div>
    </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isEmpty, forEach } from 'lodash';

import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import WSearchField from '@/components/form/SearchField';
import LmsLogAPI from '@/api/log/integrated-log';

export default {
  name: 'WLogKeywordMapCount',
  props: {
    wordCount: {
      type: Array,
    },
    active: {
      type: Boolean,
      default: false,
    },
    checkGroupFlag: {
      type: Boolean,
      defalut: false,
    },
  },
  components: {
    WSearchField,
  },
  computed: mapGetters(['selectedNode', 'analysisDateParams']),
  data() {
    return {
      tempWordCountData: [],
      currentSelectGroup: null,
      checkList: [],
      timer: null,
      columnDefault,
      showSearchTool: false,
      groupData: [],
      nodeData: [],
      height: 0,
      sum: 0,
      wordCountData: [],
      wordCountGroupData: [],
      nodeColumn: [
        {
          label: '발생률',
          prop: 'wordCount',
          scopedSlot: 'wordCount-slot',
        },
      ],
      groupColumn: [
        {
          headerAlign: 'center',
          align: 'center',
          type: 'selection',
          width: '50px',
          prop: 'check_flag',
        },
        {
          prop: 'fieldName',
          label: '필드 명',
          scopedSlot: 'groupName-slot',
        },
      ],
    };
  },
  watch: {
    selectedNode() {
      this.$refs.groupSearch.clear();
      this.$refs.nodeSearch.clear();
      if (this.active) {
        this.loadGroupField();
      }
    },
    analysisDateParams() {
      this.$refs.groupSearch.clear();
      this.$refs.nodeSearch.clear();
    },
    active: {
      handler(to) {
        if (!to) {
          this.wordCountData = [];
          this.wordCountGroupData = [];
        } else {
          this.loadGroupField();
        }
      },
    },
    wordCount: {
      deep: true,
      handler() {
        this.nodeData = [];
        this.wordCountData = [];
        const wordCountElem = document.getElementsByClassName('wordCountInfo')[0];
        const height = wordCountElem.getBoundingClientRect().height;
        this.height = height - 300;
        this.setWordTreeData();
      },
    },
  },
  methods: {
    /**
     * 상단 필드명 클릭 시 발생 빈도 테이블 데이터 변경
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    filterNodeTable(row) {
      this.sum = 0;
      this.currentSelectGroup = row.fieldId;
      this.wordCountData = cloneDeep(this.nodeData.filter((node) => {
        if (node.key === row.fieldId) {
          this.sum += node.size;
        }
        return node.key === row.fieldId;
      }));
      this.tempWordCountData = cloneDeep(this.nodeData.filter((node) => node.key === row.fieldId));
    },
    /**
     * 저장소 선택 시 파라미터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getIndexParams() {
      const params = { type: this.selectedNode.type, dataindexId: this.selectedNode.dataindexId };
      return params;
    },
    /**
     * 필터 선택 시 파라미터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getFilterParams() {
      const params = { type: this.selectedNode.type, customFilterId: this.selectedNode.customFilterId };
      return params;
    },
    /**
     * 트리메뉴 선택에 따른 파라미터 작성 함수
     * @author leesy918
     */
    setParameter() {
      let params;
      if (this.selectedNode.type === 'dataindex') {
        params = this.getIndexParams();
      } else if (this.selectedNode.type === 'filter') {
        params = this.getFilterParams();
      } else if (this.selectedNode.type === 'group') {
        params = {
          type: 'group',
          filterGroupId: this.selectedNode.filterGroupId,
        };
      } else {
        params = {
          type: 'root',
        };
      }
      params = {
        ...params,
        start: 0,
      };

      return params;
    },
    /**
     * 키워드맵 필드 그룹 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadGroupField() {
      const params = this.setParameter();
      LmsLogAPI.getGroupField(params).then((response) => {
        if (response.data.success) {
          this.wordCountGroupData = response.data.data;
          if (!isEmpty(this.wordCountGroupData) && !isEmpty(this.$refs.logGroupTable)) {
            this.currentSelectGroup = this.wordCountGroupData[0].fieldId;
            this.$refs.logGroupTable.$children[0].setCurrentRow(this.wordCountGroupData[0]);
          }
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드 그룹', false));
        throw new Error(e);
      });
    },
    /**
     * 그룹 선택
     * @author leesy918
     * @return {[type]} [description]
     */
    changeSelection(data) {
      this.checkList = data;
      this.$emit('groupCheck', data);
    },
    /**
     * 마우스 오버 해제 시 차트 불투명도 해제
     * @author leesy918
     * @return {[type]} [description]
     */
    leaveNode() {
      clearTimeout(this.timer);
      this.$emit('clearWord');
    },
    /**
     * 발생횟수 테이블에 마우스 오버 시 차트 불투명도 설정
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    hoverNode(data) {
      this.timer = setTimeout(() => {
        this.$emit('getHoverWord', data);
      }, 600);
    },
    /**
     * 그룹 필드 명 검색
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    searchGroup(data) {
      // 검색할 테이블의 row들을 가져온다
      const rows = this.$refs.logGroupTable.$children[0].bodyWrapper.getElementsByClassName(
        'el-table__row',
      );
      forEach(rows, (row) => {
        const cells = row.getElementsByTagName('td');
        forEach(cells, (cell) => {
          const innerText = cell.innerText.toLowerCase();

          if (innerText.indexOf(data) > -1) {
            row.style.display = '';
            return false;
          }
          // 검색 값과 일치하지 않으면 보이지 않게 style을 설정한다.
          row.style.display = 'none';
          return true;
        });
      });
    },
    /**
     * 발생횟수 검색 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    searchNode(data) {
      if (isEmpty(data)) {
        this.wordCountData = cloneDeep(this.tempWordCountData);
      } else {
        this.wordCountData = this.tempWordCountData.filter((item) => item.id.indexOf(data) > -1);
      }
    },
    /**
     * 발생횟수 테이블 클릭 시 분석 탭의 태그 추가하는 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    wordClick(data) {
      this.$emit('wordClick', data);
    },
    /**
     * 연관 단어 발생 테이블 데이터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    setWordTreeData() {
      const wordData = cloneDeep(this.wordCount);
      // const treeData = [];
      wordData.sort((a, b) => {
        if (a.size > b.size) {
          return -1;
        } else if (a.size < b.size) {
          return 1;
        }
        return 0;
      });
      wordData.forEach((item) => {
        const isNodeExist = this.nodeData.find((data) => item.id === data.id);
        if (!isNodeExist) {
          this.nodeData.push({ id: item.id, label: item.label, size: item.size, key: item.key });
        }
      });
      this.filterNodeTable({ fieldId: this.currentSelectGroup });
    },
  },
};
</script>

<style lang="scss" scoped>
.wordCountInfo{
  p {
    line-height: 4px;
    color: #999; //$lightgray
    font-size: 12px;
  }
  .cell {
      padding: 3px 0 0 0px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/KeywordMap/LogKeywordMapCount.vue